module.exports = "/images/cd.svg?6ee98f64e0637dc470aaed322fdba29f";